module.exports = __webpack_public_path__ + "img/p1.3e8aceef.png";